import { NavLink, Outlet } from 'react-router-dom';
import { SiteChrome } from './SiteChrome';
import { useAuthStore } from '../../stores/authStore';
import { EmailVerifyBanner } from '../common/EmailVerifyBanner';
import { t } from '../../i18n/pt';
import styles from './AccountLayout.module.scss';

export function AccountLayout(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  return (
    <SiteChrome>
      <div className={styles.wrapper}>
        <aside className={styles.sidebar}>
          <p className={styles.eyebrow}>{t.nav.account}</p>
          <h2 className={styles.greeting}>Olá, {user?.firstName ?? ''}</h2>
          <nav className={styles.nav}>
            <NavLink to="/conta" end>{t.account.dashboard}</NavLink>
            <NavLink to="/conta/perfil">{t.account.profile}</NavLink>
            <NavLink to="/conta/moradas">{t.account.addresses}</NavLink>
          </nav>
          <div className={styles.logout}>
            <button type="button" onClick={() => { void logout(); }}>
              {t.nav.logout}
            </button>
          </div>
        </aside>
        <section className={styles.content}>
          <EmailVerifyBanner />
          <Outlet />
        </section>
      </div>
    </SiteChrome>
  );
}
